import { render } from "./Header.vue?vue&type=template&id=0206be34"
import script from "./Header.js?vue&type=script&lang=js"
export * from "./Header.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__